import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import GradientText from 'components/GradientText';
import JobCards from 'components/JobCards';
import MarqueeGallery from 'components/MarqueeGallery';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import { careerData } from 'components/MissionAndValuesSection/mockData';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCareerPage, fetchCareer } from 'store/slices/CareerSlice';
// {
//     "fs_title": "1 We’re always looking people to <b>help us become better</b>",
//     "fs_title_background": "http://54.93.104.183/storage/gallery/gallery-2.jpg",
//     "fs_view_button": "View open jobs 1",
//     "about_tag": "career opportunities 1",
//     "about_title": "<p>1 Unifer as a medium-sized international <img src=\"../../storage/shares/career.jpg\" alt=\"\" width=\"360\" height=\"160\" />company offers&nbsp;<strong>great opportunities for career growth</strong></p>",
//     "about_description": "1 We are not saying that we are unique, but believe us, companies like ours are not that common.",
//     "mission_text": "1 What makes us different",
//     "mission_small_background": null,
//     "mission_large_background": "http://54.93.104.183/storage/mission-and-values/career-mission-background.jpg",
//     "mission_cards": [
//         {
//             "title": null,
//             "text": null
//         },
//         {
//             "title": null,
//             "text": null
//         },
//         {
//             "title": null,
//             "text": null
//         }
//     ],
//     "open_jobs_tag": "Open jobs",
//     "open_jobs_title": "<p>Join our team and be part of the future of&nbsp;<strong>agricultural success</strong></p>",
//     "team_title": "Our team",
//     "team_gallery": [
//         "http://54.93.104.183/storage/gallery/gallery-1.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-8.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-2.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-3.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-4.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-5.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-6.jpg",
//         "http://54.93.104.183/storage/gallery/gallery-7.jpg"
//     ],
//     "git_tag": "Get in touch",
//     "git_title": "<p>If you would like to learn more about&nbsp;<strong>career opportunities at our company</strong><em>,</em>&nbsp;please contact us!</p>",
//     "git_text": "Even if you haven't found your dream job on this page, we may still be able to offer you an internship with us."
// }
const Career = () => {
    const dispatch = useDispatch();
    const {
        fs_title,
        about_tag,
        fs_title_background,
        about_title,
        about_description,
        open_jobs_tag,
        open_jobs_title,
        git_tag,
        git_title,
        git_text,
        team_gallery,
        team_title,
        mission_large_background,
        mission_text,
        mission_cards,
    } = useSelector(selectCareerPage);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCareer());
    }, [dispatch]);

    return (
        <>
            <Banner image={fs_title_background} buttonText="View open jobs">
                <GradientText size="middle" textColor="white">
                    <span dangerouslySetInnerHTML={{ __html: fs_title }} />
                </GradientText>
            </Banner>

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{about_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: about_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">{about_description}</GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <MissionAndValuesSection background={mission_large_background} title={mission_text} data={mission_cards} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{open_jobs_tag}</LabelButton>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="middle">
                                <span dangerouslySetInnerHTML={{ __html: open_jobs_title }} />
                            </GradientText>
                        </div>
                    </div>
                    <JobCards />
                </div>
            </section>

            <MarqueeGallery images={team_gallery} title={team_title} />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{git_tag}</LabelButton>
                        <GradientText size="middle">
                            <span dangerouslySetInnerHTML={{ __html: git_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                <span dangerouslySetInnerHTML={{ __html: git_text }} />
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <CareerForm />
        </>
    );
};

export default Career;
